<template>
  <v-container justify-center pa-3>
    
  </v-container>
</template>
<script>
export default {
  created() {
    var inApp = this.$route.query.inApp;
    if(inApp)
      this.$store.dispatch("setInApp", true);
    this.navigateTo({name: 'home'});
  }
}
</script>

<style scoped>
</style>